
import './assets/styles.css'

import banner from "./assets/img/banner.jpg"
import leters from "./assets/img/letters.png"
import Find from '../../ui/views/share/components/Find/Find'
import CarouselSevices, {servicesTravel} from '../../ui/views/share/components/CarouselServices/CarouselSevices'
import personPhone from '../../ui/assets/images/personPhone.png'
import personPhone2 from '../../ui/assets/images/personPhone2.png'


import SearchFlights from '../../ui/views/flights/search.flights.view'
import AnyQuestions from '../../ui/views/home/components/anyQuestion'






const FligthsNew = ({ isIframe }) => {
  return (
    <div>

      <CarouselSevices 
       current={servicesTravel[0].title} 
      />

      <header className='header-fligths'>
        <div className='content-buscador-fli'>
          <SearchFlights/> 
        </div>

        <div className='content-banner'>
         
             <img src={banner} alt="" />
         
         
          <div className='bg-black-fly'>
            <div className='content-letters-fly'>
              <img src={leters} alt="" />
              <p>Viaja a cualquier lugar del mundo con los mejores precios con nosotros</p>
            </div>
          </div>
        </div>
      </header>


      <section className='option-traveling'>
        <div className='card-option-traveling'>
          <div className='card-option-traveling-img'>
            <img src={personPhone2} alt="imagen1" />
          </div>
          <div className='card-option-traveling-info'>
            <h3>Viaja por Colombia</h3>
            <p>Conoce las mejores ofertas con las que contamos para que viajes por Colombia</p>
            <button>Ver Ofertas</button>
          </div>
        </div>
        <div className='card-option-traveling'>
          <div className='card-option-traveling-img'>
            <img src={personPhone} alt="imagen" />
          </div>
          <div className='card-option-traveling-info'>
            <h3>Viaja por el Mundo</h3>
            <p>Conoce las mejores ofertas con las que contamos para que viajes por el mundo</p>
            <button>Ver Ofertas</button>
          </div>
        </div>
      </section>
      <AnyQuestions title={"¿Tienes alguna duda?"}/>
    </div>
  )
}

export default FligthsNew